// extracted by mini-css-extract-plugin
export var wrapper = "FileUpload-module--wrapper--3e29-";
export var gdprDialog = "FileUpload-module--gdpr-dialog--1UBmq";
export var fieldLabelSpan = "FileUpload-module--fieldLabelSpan--2yQLQ";
export var filesList = "FileUpload-module--filesList--3BIIv";
export var deleteIcon = "FileUpload-module--deleteIcon--2E-HX";
export var icon = "FileUpload-module--icon--1wQBt";
export var filesItem = "FileUpload-module--filesItem--1oII-";
export var filesItemName = "FileUpload-module--filesItemName--1ZeTo";
export var addFile = "FileUpload-module--addFile--3JtJc";
export var uploadProgress = "FileUpload-module--upload-progress--nTuo1";
export var modal = "FileUpload-module--modal--38210";
export var modalBackground = "FileUpload-module--modalBackground--1r3LZ";
export var modalContent = "FileUpload-module--modalContent--3T_UR";
export var modal43 = "FileUpload-module--modal43--k8k_g";
export var modal43container = "FileUpload-module--modal43container--3eEdz";
export var modal169 = "FileUpload-module--modal169--2e_49";
export var dropZone = "FileUpload-module--dropZone--1IRuM";
export var modal169container = "FileUpload-module--modal169container--2ARP3";
export var dragActive = "FileUpload-module--dragActive--3itib";
export var uploadButton = "FileUpload-module--uploadButton--3pP0S";
export var closeButton = "FileUpload-module--closeButton--E5eV7";
export var spinAround = "FileUpload-module--spinAround--1bGeP";